import { render } from "./Home.vue?vue&type=template&id=652ccf99&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=652ccf99&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/huwei-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652ccf99"]])

export default __exports__